var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('ImportManualOrderForm',{on:{"importedFile":_vm.importedFile,"upload":_vm.clearWorkData}}),_c('ProgressBar'),_c('ManualOrderWorkList',{ref:"workList",staticClass:"mt-4"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }